export class ProfileController {
  constructor($scope, $route, $modal, $sce, toastr, socket, UserService, LikeService, LockService, $rootScope, $location) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.modal = $modal;
    this.route = $route;
    this.sce = $sce;
    this.socket = socket;
    this.toastr = toastr;
    this.UserService = UserService;
    this.LikeService = LikeService;
    this.LockService = LockService;

    this.init();
  }

  init() {
    this.socket.on(`like_update`, () => this.isMutualLiked());
    this.userId = this.route.current.params.id;
    this.scope.filterInfo = { show: false, region: false, avatar: false, age: false };
    this.scope.liked = false;
    this.scope.isMutualLiked = false;

    this.scope.reportModalOpen = () => {
      this.modal.open({
        templateUrl: 'reportModal.html',
        controller: 'ReportModalController'
      }).result.catch(angular.noop);
    };

    async.parallel([
      callback => {
        this.UserService.getCurrentUser()
          .then((response) => { let user = response.data;
            this.rootScope.currentUserProfile = user.data;
            callback();
          })
          .catch((response) => { let err = response.data;
            callback(err);
          });
      },

      callback => {
        this.UserService.getUserProfile(this.userId)
          .then((response) => { let user = response.data;
            this.scope.userData = user.data;
            callback();
          })
          .catch((response) => { let err = response.data;
            callback(err);
          });
      }
    ], (err) => {
      if(err) {
        this.scope.isLoadedPage = true;
        console.error(err);
      } else if(!this.scope.userData) {
        this.scope.isLoadedPage = true;
      } else {
        if(!this.scope.userData.filters) {
          this.scope.userData.filters = {};
        }

        this.scope.isOwnPage = this.rootScope.currentUserProfile._id == this.userId;
        this.scope.isAvatarApproved = !!this.rootScope.currentUserProfile.photoprofile.approved;

        if (!this.scope.isOwnPage) {
          this.isLiked();
          this.isMutualLiked();

          let newVisit = {
            user: this.userId,
            userSaw: false,
            visitor: this.rootScope.currentUserProfile._id,
            count: 1,
            status: true
          };

          this.socket.emit('visit_create', JSON.stringify(newVisit));
        }

        if (this.scope.userData.informationPersonal && this.scope.userData.informationPersonal.shortDescription) {
          this.scope.userData.informationPersonal.shortDescription = this.scope.userData.informationPersonal.shortDescription.replace(/\n/g, "<br>");
          this.scope.userData.informationPersonal.shortDescription = this.sce.trustAsHtml(this.scope.userData.informationPersonal.shortDescription);
        }

        this.scope.isLoadedPage = true;
      }
    })
  }

  isLiked() {
    this.LikeService.interestedInYouLikesCheck({ giver: this.rootScope.currentUserProfile._id, receiver: this.scope.userData._id })
        .then((_res) => { let response = _res.data;
          if (response.status == 'isLiked') {
            this.scope.liked = true;
          } else {
            this.scope.liked = false;
          }
        })
        .catch((response) => { let err = response.data;
          this.scope.liked = false;
          console.error(err);
        });
  }

  isMutualLiked() {
    this.LikeService.isMutualLiked(this.rootScope.currentUserProfile._id, this.scope.userData._id)
      .then((response) => { let result = response.data;
        let age = this.rootScope.getAge(this.rootScope.currentUserProfile);
        this.scope.isMutualLiked = !!result.data;
        this.scope.filterInfo.region = this.scope.userData.filters.region && this.scope.userData.filters.region._id !== this.rootScope.currentUserProfile.region;
        this.scope.filterInfo.avatar = _.some(this.rootScope.currentUserProfile.photoprofileHistory, (ava) => ava.approved === true) ? false : this.scope.userData.filters.photorequired && (!this.rootScope.currentUserProfile.photoprofile.url || this.rootScope.currentUserProfile.photoprofile.url && !this.rootScope.currentUserProfile.photoprofile.approved);
        this.scope.filterInfo.age = this.scope.userData.filters.minage > age || this.scope.userData.filters.maxage < age;
        this.scope.filterInfo.show = !this.scope.isMutualLiked && this.scope.userData.filters.matchfilters && this.scope.userData._id !== this.rootScope.currentUserProfile._id && (this.scope.filterInfo.region || this.scope.filterInfo.avatar || this.scope.filterInfo.age);
      })
      .catch((response) => { let err = response.data;
        console.log(err);
      })

  }

  showDetailedProfile() {
    if (this.rootScope.isVip() || this.scope.isOwnPage) {
      this.location.path('/profilerd/album/id/' + this.scope.userData._id)
    } else {
      this.toastr.info(`Para ver las fotos privadas de este perfil debes tener una cuenta VIP pagada: <a href="/homerd/centrodepago">Centro de pago</a>`)
    }
  }

  setLike() {
    if (this.rootScope.currentUserProfile.status == 0) {
      this.toastr.warning('Su perfil es desactivado, no se puede hacer esto.');
      return;
    }

    let params = {
      giver: this.rootScope.currentUserProfile._id,
      receiver: this.scope.userData._id
    };

    if (!this.scope.liked) {
      this.scope.liked = true;
      this.socket.emit('like_set', JSON.stringify(params));
    } else {
      this.scope.liked = false;
      this.socket.emit('like_remove', JSON.stringify(params));
    }

    this.toastr.info('Hemos notificado a ' + this.scope.userData.username + ' que te gusta');
  }

  blockProfile() {
    if (this.rootScope.currentUserProfile.status == 0) {
      this.toastr.warning('Your profile is deactivated, you can\'t do this.');
      return;
    }

    if (this.rootScope.currentUserProfile._id == this.userId) {
      this.toastr.error('No puedes bloquear a este perfil');
      return;
    }
    var params = {
      user: this.rootScope.currentUserProfile._id,
      lockedUser: this.userId
    };

    this.LockService.lockUser(params)
      .then((_res) => { let response = _res.data; let status = response.status;
        if (status == 200) {
          this.toastr.info('El perfil ya ha sido agregado a tu lista de contactos bloqueados anteriormente');
        }
        if (status == 201) {
          this.toastr.info('El perfil ha sido agregado a tu lista de perfiles bloqueados');
        }
      })
      .catch((response) => { let error = response.data;
        console.log('profile blockprofile error!');
      })
  }
}
